// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"a29af7bd","742":"597e1320","787":"9b8b4e18","858":"38a4e686"}[chunkId] + ".chunk.js";
};